import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';

import { DeviceContext, deviceType, CredentialContext, credentialType } from '@providers';
import { useSnackbar } from '@src/providers/SnackbarProvider';

import DesktopEmailVerifyRequestPage from './DesktopEmailVerifyRequestPage';
import MobileEmailVerifyRequestPage from './MobileEmailVerifyRequestPage';

import { SEND_VERIFY_EMAIL } from '@src/pages/EmailVerifyRequest/queries';
import { sendVerifyEmail } from '@src/pages/EmailVerifyRequest/__generated__/sendVerifyEmail';

import { redirectToLoginWithCurrentPath } from '@src/utils/authCheck';
import { baseUrl } from '@src/app/routes';

const EmailVerifyRequestPage = () => {
  const history = useHistory();
  const { isMobile } = useContext<deviceType>(DeviceContext);
  const { currentUser } = useContext<credentialType>(CredentialContext);
  const { showSnackbar } = useSnackbar();

  const [sendVerifyEmail] = useMutation<sendVerifyEmail>(SEND_VERIFY_EMAIL, {
    onCompleted: (data) => {
      const errors = data?.sendVerifyEmail?.errors;

      if (errors?.length) {
        showSnackbar({ message: errors[0].message });

        if (errors[0].message === 'Email is already verified.') {
          history.push(baseUrl);
        }
      }
    },
  });

  useEffect(() => {
    if (!currentUser?.token) {
      showSnackbar({ message: 'You should login.' });

      redirectToLoginWithCurrentPath(history);
    } else {
      sendVerifyEmail();
    }
  }, []);

  const handleClickVerifyLaterButton = () => {
    history.push(baseUrl);
  };

  const handleClickResendEmailButton = () => {
    sendVerifyEmail();
  };

  return isMobile ? (
    <MobileEmailVerifyRequestPage
      userEmail={currentUser?.user?.email}
      onClickVerifyLaterButton={handleClickVerifyLaterButton}
      onClickResendEmailButton={handleClickResendEmailButton}
    />
  ) : (
    <DesktopEmailVerifyRequestPage
      userEmail={currentUser?.user?.email}
      onClickVerifyLaterButton={handleClickVerifyLaterButton}
      onClickResendEmailButton={handleClickResendEmailButton}
    />
  );
};

export default EmailVerifyRequestPage;
